import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Fab, Grid } from '@material-ui/core'
import { connect } from 'react-redux'
import MuiTheme from '../../../MuiTheme';
import { ReduxStore } from '../../../stores';
import { TExercise } from '../../../Models/Exercise/@types';
import { RouteComponentProps, withRouter } from 'react-router';
import Form from '../../../Models/Exercise/Form';
import { OExercise } from '../../../Models/Exercise/Model';
import SimpleCard, { SimpleCardOptionsConfig } from '../../../Components/SimpleCard';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import { AxiosPromise } from 'axios';
import CircularLoader from '../../../Components/Loader/CircularLoader';
import { TDispatch } from '../../../Resources/GarbageUtils';

interface IStateProps {
    mainList?: Array<TExercise>
}

interface IDispatchProps {
    getItemsList: (params: any) => AxiosPromise
    deleteExercise: (exerciseId: string) => AxiosPromise
    togglePublish: (exercise: TExercise) => AxiosPromise
}

interface IState {
    showForm: boolean
    itemToEdit?: TExercise
    showConfrimationDialog: boolean
    itemToDelete?: TExercise
    loading: boolean
}

interface OwnProps {

}

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, RouteComponentProps<{ sectionId: string }>, OwnProps { }

class Exercise extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showForm: false,
            showConfrimationDialog: false,
            loading: false
        }
    }

    handleEdit = (exercise: TExercise) => this.setState({ itemToEdit: exercise, showForm: true })

    togglePublishHandler = (exercise: TExercise) => this.props.togglePublish(exercise);

    optionsConfig: Array<SimpleCardOptionsConfig> = [
        { icon: 'lock', label: 'Publish', handler: this.togglePublishHandler },
        { icon: 'edit', label: 'Edit', handler: this.handleEdit },
        { icon: 'delete', label: 'Delete', handler: (exercise: TExercise) => this.setState({ itemToDelete: exercise, showConfrimationDialog: true }) }
    ]

    async componentDidMount() {
        await this.setState({ loading: true });
        await this.props.getItemsList({ filter: { where: { sectionId: this.props.match.params['sectionId'] } } }).catch(error => { console.log('Error getting exercise list', error.response.data) });
        await this.setState({ loading: false });
    }

    closeForm = () => {
        this.setState({ showForm: false, itemToEdit: undefined });
    }

    handleDeleteItem = () => {
        if (this.state.itemToDelete) {
            this.props.deleteExercise(this.state.itemToDelete.id);
            this.setState({ showConfrimationDialog: false });
        }
    }

    render() {
        const { classes, mainList = [] } = this.props;
        const { itemToEdit, itemToDelete, showForm, showConfrimationDialog, loading } = this.state;
        return (
            <div className={classes.root} >
                {
                    loading
                        ?
                        <CircularLoader />
                        :
                        !showForm
                            ?
                            <Grid container spacing={5} className={classes.listContainer} >
                                {
                                    mainList.sort((a, b) => a.number - b.number).map((exercise, index) => {
                                        return (
                                            <Grid item sm={12} key={index} >
                                                <SimpleCard onclick={() => this.handleEdit(exercise)} optionsConfig={this.optionsConfig} multiline entity={exercise} description={`${exercise.number}. ${exercise.question}`} />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                            : null
                }
                <Fab
                    color="secondary"
                    className={classes.addButton}
                    onClick={(e: any) => this.setState({ showForm: true })}
                >
                    <i className='material-icons' >add</i>
                </Fab>
                {
                    showForm
                        ?
                        <Form open={showForm} exercise={itemToEdit} onClose={this.closeForm} /> : null
                }
                <ConfirmationDialog
                    openState={showConfrimationDialog}
                    onAgree={this.handleDeleteItem}
                    onClose={() => this.setState({ showConfrimationDialog: false })}
                    title={itemToDelete ? `${itemToDelete.number}. Exercise` : 'This Exercise'}
                    message={`Are you sure to delete ${itemToDelete ? `${itemToDelete.number}. ${itemToDelete.question}` || (itemToDelete.number + '. Exercise') : 'This Exercise'}`}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({
    mainList: state.Exercises.mainList
})

const mapDispatchToProps = (dispatch: TDispatch): IDispatchProps => ({
    getItemsList: (params?: any) => dispatch(OExercise.getItemsList(params)),
    deleteExercise: (exerciseId: string) => dispatch(OExercise.deleteItem(exerciseId, {}, undefined, { deletedItemId: exerciseId })),
    togglePublish: (exercise) => dispatch(OExercise.postActivity(OExercise.Activities.TOGGLE_PUBLISH, {}, { id: exercise.id, publish: !exercise.isPublished }))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 25,
        flexDirection: 'column'
    },
    addButton: {
        position: 'fixed',
        right: '24px', bottom: '24px'
    },
    listContainer: {
        width: '85%',
        marginTop: 36
    }
})

export default withRouter(connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Exercise)))